import { MessageBar, MessageBarType, Spinner } from "@fluentui/react";
import { Query } from "react-apollo";
import { MyContext } from "../../../../context";
import EditPolicy from "./EditPolicy";
import * as QueryPR from '../PolicyQuery';
import React, { Component } from 'react';

export default class EditPolicyContainer extends Component {
    static contextType = MyContext

    constructor(props) {
        super(props);
        this.state = {
            query: 0,
        };
        this.data = null;
    }

    render() {
        const { auth, id, apol, hidePanel } = this.props
        return (
            <div>
                {/*Edit policy*/}
                {id != null && (
                    <Query
                        query={QueryPR.queryPolicy}
                        fetchPolicy="network-only"
                        variables={{ auth, id }}>
                        {({ loading, error, data }) => {
                            if (loading) {
                                return (
                                    <Spinner label={this.context.getTranslation("common", "loading")} ariaLive="assertive" labelPosition="top" />
                                )
                            }
                            if (error) {
                                console.log(error)
                                return (
                                    <MessageBar
                                        messageBarType={MessageBarType.error}
                                        isMultiline={false}
                                        dismissButtonAriaLabel="Close"
                                    >
                                        {this.context.getTranslation("compliance", "error")}
                                    </MessageBar>
                                )
                            }
                            if (data.getPolicy == null) {
                                return (<MessageBar>
                                    {this.context.getTranslation("compliance", "noDataPolicy")}
                                </MessageBar>)
                            }
                            if (data.getPolicy.basedOn == "Scorecard")
                            {
                                const policyId = data.getPolicy.id;
                                var objectReferenceId = ""
                                if (data.getPolicy.aIScorecardInfos != null) {
                                    objectReferenceId = data.getPolicy.aIScorecardInfos[0].scorecardId
                                }

                                return (
                                    <Query
                                        query={QueryPR.queryPolicyAlarm}
                                        variables={{ policyId, objectReferenceId }}
                                        fetchPolicy="network-only"
                                    >
                                        {({ loading: queryLoading, error: queryError, data: queryData }) => {
                                            if (queryLoading) {
                                                return (
                                                    <Spinner
                                                        label={this.context.getTranslation("common", "loading")}
                                                        ariaLive="assertive"
                                                        labelPosition="top"
                                                    />
                                                );
                                            }
                                            if (queryData.getPolicyAlarm.id == null) {
                                                return (
                                                    <EditPolicy
                                                        data={data.getPolicy}
                                                        theme={this.props.theme}
                                                        closePanel={hidePanel}
                                                        apol={apol}
                                                        auth={auth}
                                                        refreshPolicies={this.props.refreshPolicies}
                                                        setMessageError={this.props.setMessageError}
                                                        userRules={this.props.userRules}
                                                    />
                                                );
                                            }
                                            if (queryError) {
                                                console.log(queryError);
                                                return (
                                                    <MessageBar
                                                        messageBarType={MessageBarType.error}
                                                        isMultiline={false}
                                                        dismissButtonAriaLabel="Close"
                                                    >
                                                        {this.context.getTranslation("compliance", "error")}
                                                    </MessageBar>
                                                );
                                            }

                                            return (
                                                <EditPolicy
                                                    data={data.getPolicy}
                                                    theme={this.props.theme}
                                                    alarm={queryData.getPolicyAlarm}
                                                    closePanel={hidePanel}
                                                    apol={apol}
                                                    auth={auth}
                                                    refreshPolicies={this.props.refreshPolicies}
                                                    setMessageError={this.props.setMessageError}
                                                    userRules={this.props.userRules}
                                                />
                                            );
                                        }}
                                    </Query>
                                );

                            }
                            return (
                                <EditPolicy
                                    data={data.getPolicy}
                                    theme={this.props.theme}
                                    closePanel={hidePanel}
                                    apol={apol}
                                    auth={auth}
                                    refreshPolicies={this.props.refreshPolicies}
                                    setMessageError={this.props.setMessageError}
                                    userRules={this.props.userRules}
                                />
                            );
                        }}
                    </Query>
                )
                }
                {/*Create policy*/}
                {
                    id === null && (
                        <div>
                            <EditPolicy
                                closePanel={hidePanel}
                                theme={this.props.theme}
                                apol={apol}
                                auth={auth}
                                refreshPolicies={this.props.refreshPolicies}
                                setMessageError={this.props.setMessageError}
                                userRules={this.props.userRules}
                            />
                        </div>
                    )
                }
            </div>
        )
    }

}